module.exports = __webpack_public_path__ + "teqbahn-assets/media/36.12837915.png";